<template>

    <v-dialog
            v-model="dialog"
            width="80%">

        <v-card>
            <v-card-title style="padding-left: 44px; padding-top:30px;"
                          primary-title>
                {{ resource.first_name + ' ' + resource.last_name + (resource.jmbg ? ' (' + resource.jmbg + ')' : '') }}
                - pregled uloga
            </v-card-title>

            <v-card-text style="min-height: 440px !important;;">

                <!-- Multiselect field -->

                <v-container fluid grid-list-sm>
                    <v-layout row wrap>
                        <v-col cols="4">
                            <v-autocomplete
                                    v-model="form.role"
                                    label="Odaberi ulogu"
                                    :items="roles"
                                    :item-text="'title'"
                                    :item-value="'id'"
                                    @change="pickedRole"
                                    chips>
                            </v-autocomplete>
                        </v-col>

                        <!--<v-col cols="3">
                            <v-autocomplete
                                    v-model="form.organisationType"
                                    label="'Razina pristupa'"
                                    :items="organisationTypes"
                                    @change="pickedModelType"
                                    chips>
                            </v-autocomplete>
                        </v-col>-->

                        <v-col cols="3"
                               v-if="dropdownItems.length > 0">
                            <v-autocomplete
                                    v-model="form.organisationId"
                                    :label="'Definicija pristupa'"
                                    :items="dropdownItems"
                                    chips>
                            </v-autocomplete>
                        </v-col>

                        <v-col cols="2">
                            <v-btn style="width: 100%; margin: 15px 0;" @click="addRoles()" color="primary">Dodijeli
                            </v-btn>
                        </v-col>

                        <v-col cols="12">
                            <span>{{ roles_user.length > 0 ? 'Uloge koje ima korisnik:' : 'Korisnik nema nijednu ulogu u sustavu!'}}</span>
                            <v-list two-line>
                                <template>
                                    <div v-for="(item, index) in roles_user"
                                         v-bind:key="Math.random() + '' + item.id + '' + item.organisation_type + '' + item.organisation_id">

                                        <v-list-item
                                            :disabled="item.valid_to"
                                                :key="'dt_' + item.id"
                                                three-line
                                                ripple
                                        >
                                            <v-list-item-action>
                                                <v-icon color="primary">mdi-lock</v-icon>
                                            </v-list-item-action>

                                            <v-list-item-content>
                                                <v-list-item-title>{{ item.role.title }}</v-list-item-title>


                                                <v-list-item-subtitle v-if="item.organisation">{{ item.organisation.name }}</v-list-item-subtitle>
                                              <v-list-item-subtitle> Vrijedi od : {{

                                                  formatDate(item.valid_from)
                                                }}</v-list-item-subtitle>
                                            </v-list-item-content>

                                            <v-list-item-action>
                                              <span v-if="item.valid_to">Datum isteka: {{ formatDate(item.valid_to) }}</span>
                                              <div v-else>
                                                <v-dialog
                                                    v-model="dialog_removeRole[index]"
                                                    width="500">

                                                  <template v-slot:activator="{on, attrs}">
                                                    <v-btn v-bind="attrs" v-on="on" icon>
                                                      <v-icon
                                                          color="darken-2"
                                                          >mdi-delete
                                                      </v-icon>
                                                    </v-btn>
                                                  </template>

                                                  <v-card>
                                                    <v-card-title
                                                        primary-title>
                                                      Jeste li sigurni?
                                                    </v-card-title>

                                                    <v-card-text style="padding-top: 20px;">
                                                      Operacija koju ste zatražali može imati za posljedicu gubitak određenog dijela podataka. Jeste li sigurni da želite ispisati djelatnika iz Vaše škole?
                                                      <br><br>
                                                      <v-checkbox label="Prikaži djelatnika u izvještajima za ovu školsku godinu?" v-model="form.keep_student"></v-checkbox>
                                                    </v-card-text>

                                                    <v-divider></v-divider>

                                                    <v-card-actions>
                                                      <v-spacer></v-spacer>
                                                      <v-btn @click="(closeDialog(), form.keep_student = false)" depressed large outlined>Odustani</v-btn>
                                                      <v-btn @click="deleteRole(item, index)" color="error" depressed large>Ispiši</v-btn>
                                                    </v-card-actions>
                                                  </v-card>
                                                </v-dialog>
                                              </div>

                                            </v-list-item-action>

                                        </v-list-item>
                                        <v-divider></v-divider>
                                    </div>
                                </template>
                            </v-list>
                        </v-col>
                    </v-layout>
                </v-container>
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="accent" @click="dialog = false">U redu</v-btn>
            </v-card-actions>
        </v-card>

    </v-dialog>
</template>

<script>

    import {serverBus} from "../../main";
    import moment from "moment/moment";
    import ApiV2 from "../../services/ApiV2";

    export default {

        created: function () {
            serverBus.$on('close-user-roles-dialog', () => {
                this.dialog = false;
            });

            serverBus.$on('show-user-roles-dialog', (resource) => {
                this.resource = resource;

                this.dialog = true;

                this.$axios.post('ostalo/uloga/sve').then(response => {
                    this.roles = response.data;
                });

                this.$axios.post('ostalo/uloga/options').then(response => {
                    this.schools = response.data.schools;
                    this.cantons = response.data.cantons;
                });
                this.$nextTick(() => {
                  this.getUserRoles();
                })


                /*if (this.$checkPermission('roles delete')) {
                  this.organisationTypes.push({value: 'Everything', text: 'Pristup svemu'});
                }*/
            });
        },

        methods: {
          formatDate(date){
            return moment(date).format("DD.MM.YYYY.");
          },
            getUserRoles() {
                this.$axios.post('ostalo/uloga/korisnik/' + this.resource.id).then(response => {
                    const roles_user = response.data;


                    let items = [];

                    for (let i = 0; i < roles_user.length; i++) {
                        switch (roles_user[i].organisation_type) {
                            case 'School':
                                items = this.schools;
                                roles_user[i].organisationTypeText = 'Škola';
                                break;
                            case 'Canton':
                                items = this.cantons;
                                roles_user[i].organisationTypeText = 'Županija';
                                break;
                            case 'Everything':
                                roles_user[i].organisationTypeText = 'Pristup svemu';
                                break;
                            default:
                                this.dropdownItems = [];
                        }

                        for (let j = 0; j < items.length; j++) {
                            if (items[j].value === roles_user[i].organisation_id) {
                              if(roles_user[i].organisation_type != 'Everything'){
                                roles_user[i].modelText = items[j].text;
                                break;
                              } else {
                                break;
                              }
                            }
                        }
                    }

                    this.roles_user = roles_user;
                    this.dialog_removeRole = Array(this.roles_user.length).fill(false)
                });
            },

            addRoles() {
                this.$axios.post('ostalo/uloga/korisnik/' + this.resource.id + '/dodaj', this.form).then(() => {
                    this.getUserRoles();
                    serverBus.$emit('refresh-employee-profile');
                    this.form = {};
                });
            },

            deleteRole(item) {
                this.form.model_has_role_id = item.id;

              ApiV2.post('roles/revoke_user_role', this.form).then(() => {
                    this.getUserRoles();
                    this.closeDialog()
                    serverBus.$emit('refresh-employee-profile');
                });
            },

            closeDialog() {
                this.dialog_removeRole = Array(this.roles_user.length).fill(false)
            },

            pickedRole() {
                this.form.roleId = this.form.role;
                this.dropdownItems = [];

                switch (this.form.role) {
                    case 1:
                        this.form.organisationType = 'Everything';
                        this.form.organisationId = 1;
                        break;
                    case 2:
                        this.form.organisationType = 'Canton';
                        this.dropdownItems = this.cantons;
                        break;
                    default:
                        this.form.organisationType = 'School';
                        this.dropdownItems = this.schools;
                }

                if (this.dropdownItems?.length === 1)
                    this.form.organisationId = this.dropdownItems[0].value;
            },
        },
        watch: {
            dialog: {
                handler() {
                    if (this.dialog === false) {
                        this.form = {};
                    }
                },
                deep: true
            },

        },

        data: function () {
            return {
                dialog: false,
                dialog_removeRole: undefined,
                resource: {},
                roles: [],
                schools: [],
                cantons: [],
                departments: [],
                roles_user: [],
                dropdownItems: [],
                form: {},
                /*organisationTypes: [
                  {value: 'Canton', text: 'Županija'},
                  {value: 'School', text: 'Škola'},
                ],*/
            }
        },

    }
</script>
